
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"6","height":"16","viewBox":"0 0 6 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 .8a1.2 1.2 0 100 2.402A1.2 1.2 0 003 .8z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M3 .2c-.992 0-1.8.807-1.8 1.8 0 .992.808 1.8 1.8 1.8.993 0 1.8-.808 1.8-1.8C4.8 1.006 3.993.2 3 .2zm0 2.4a.6.6 0 110-1.201.6.6 0 010 1.2zM3.6 5.6H2.4v9.6h1.2V5.6z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M3.6 5H2.4a.6.6 0 00-.6.6v9.6a.6.6 0 00.6.6h1.2a.6.6 0 00.6-.6V5.6a.6.6 0 00-.6-.6z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M3 13.4l-1.8 1.8h3.6L3 13.4z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M5.224 14.774l-1.8-1.8a.6.6 0 00-.849 0l-1.8 1.8A.599.599 0 001.2 15.8h3.6a.6.6 0 00.424-1.025zM2.649 14.6L3 14.248l.352.351h-.703zM1.2 5.6L3 7.4V5.6H1.2z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M3 5H1.2a.6.6 0 00-.425 1.025l1.8 1.8a.605.605 0 00.654.13A.6.6 0 003.6 7.4V5.6A.6.6 0 003 5z","fill":"#E2E8F0"}})])
          )
        }
      }
    